import { UsageAltNav } from '@clearkit/icons';

import { APIUsagePage } from '~/components/api/APIUsagePage';
import { PageLayout } from '~/components/PageLayout';

export const PageAPIUsage = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <UsageAltNav />
      </PageLayout.Tile>
      <PageLayout.Heading>API Usage</PageLayout.Heading>
      <PageLayout.SubHeading>
        Manage your API & Developer settings
      </PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <APIUsagePage />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
